<template>
  <div class="group-detail">
    <el-form
      :model="formData"
      label-width="100px"
      label-position="right"
      :rules="editRules"
    >
      <el-form-item label="群组名称:" prop="name">
        <el-input
          v-model="formData.name"
          placeholder="-请输入-"
          clearable
          :readonly="isViewing"
          maxlength="50"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="所属组织:">
        <!-- 所属组织一旦确定是不可以改的 -->
        <el-input v-model="formData.orgName" :readonly="true"></el-input>
      </el-form-item>
      <el-form-item label="是否默认">
          <el-select
            v-model="formData.isDefault"
            placeholder="-请选择-"
            clearable
            :disabled="isViewing"
          >
            <el-option
              v-for="option in defList"
              :key="option.id"
              :label="option.name"
              :value="option.id"
            ></el-option>
          </el-select>
        </el-form-item>
      <el-form-item label="备注:" prop="remark">
        <el-input
          v-model="formData.remark"
          type='textarea'
          :rows='5'
          placeholder="-请输入-"
          clearable
          :readonly="isViewing"
          maxlength="100"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="人员列表:">
        <div class="member_c">
          <template v-if="userRelationList && userRelationList.length > 0">
            <div class="selected_c">
              <el-tag
                v-for="item in userRelationList"
                :key="item.userId"
                :closable="isEditing"
                @close="removeUser(item)"
                >{{ item.userName }}</el-tag
              >
              <!-- <el-tag v-for="index in 10" :key="index" :closable="isEditing">哈哈哈</el-tag> -->
            </div>
          </template>
          <template v-else>
            <div class="empty_c">暂无成员</div>
          </template>
          <el-button
            type="primary"
            size="small"
            @click="addMember"
            v-if="isEditing"
            >新增</el-button
          >
        </div>
      </el-form-item>
    </el-form>
    <div class="footer" v-if="isEditing">
      <el-button @click="doCancel" type="info">取消</el-button>
      <el-button type="primary" @click="doSubmit">{{
        isEditing ? "保存" : "确定"
      }}</el-button>
    </div>
    <div class="footer" v-else>
      <el-button @click="doCancel" type="info">关闭</el-button>
    </div>

    <el-dialog title="选择" :visible.sync="dialogVisible">
      <div class="choose_c">
        <div class="tree_c wrapper">
          <div class="title_c">通信录</div>
          <div class="head_c">
            <div
              class="tab"
              @click="changeTab('depart')"
              :class="[currentTab == 'depart' ? 'tab-active' : '']"
            >
              部门
            </div>
            <div
              class="tab"
              @click="changeTab('group')"
              :class="[currentTab == 'group' ? 'tab-active' : '']"
            >
              群组
            </div>
          </div>
          <div class="body_c">
            <el-tree
              :load="loadNode"
              lazy
              :expand-on-click-node="false"
              @node-click="treeNodeClick"
              :props="treeProps"
            >
            </el-tree>
          </div>
        </div>
        <!-- 中间栏候选 -->
        <div class="candidate_c wrapper">
          <div class="title_c">{{ currentDepartmentName }}</div>
          <div class="head_c">
            <el-button type="text" @click="middleAllSelected">全选</el-button>
          </div>
          <div class="body_c">
            <ul>
              <li
                class="el-tree-node"
                v-for="dept in middleDepartList"
                :key="dept.id"
              >
                <div class="el-tree-node__content">
                  <el-checkbox
                    :value="isDepartSelected(dept.id)"
                    @change="changeSelectDept(dept)"
                    :disabled="true"
                    >{{ dept.name }}</el-checkbox
                  >
                </div>
              </li>
              <li
                class="el-tree-node"
                v-for="user in middleUserList"
                :key="user.id"
              >
                <div class="el-tree-node__content">
                  <el-checkbox
                    :value="isUserSelected(user.id)"
                    @change="changeSelectUser(user)"
                    >{{ user.displayName || user.name }}</el-checkbox
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 右边已经选择的列表 -->
        <div class="result_c wrapper">
          <div class="title_c">已选列表</div>
          <div class="head_c">
            <el-button type="text" icon="el-icon-delete" @click="removeAllRight"
              >移除全部</el-button
            >
          </div>
          <div class="body_c">
            <ul>
              <li
                class="el-tree-node"
                v-for="user in rightUserList"
                :key="user.id"
              >
                <div class="el-tree-node__content">
                  <i class="el-icon-delete" @click="removeRightUser(user)"></i>
                  <span>{{ user.displayName || user.name }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false" type="info">取 消</el-button>
        <el-button type="primary" @click="submitSelectedList">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  groupDetailService,
  addGroupUserService,
  deleteGroupUserService,
  modifyGroupService,
} from "../../services/groupService";
import { getSubService, getSubUserService } from "../../services/departService";
import { getDeptListService } from "../../services/sysSettingService";
import Variables from "@/utils/consts";
export default {
  name: "GroupDetail",
  data() {
    return {
      formData: {
        name: "",
        orgName: "",
        remark: "",
      },
      orgId: null, // 群组所属的组织id
      userRelationList: [],
      id: null,
      type: "",
      currentDepartmentName: "部门",
      dialogVisible: false,
      treeProps: {
        label: "name",
      },
      currentTab: "depart",
      currentDepartId: null, // 记录左侧当前选定的部门，然后中间去获取该部门下的部门和人员
      middleDepartList: [],
      middleUserList: [],
      rightDepartList: [],
      rightUserList: [],
      defList: [
        {id: 0, name:"否"}, 
        {id: 1, name:"是"}
      ]
    };
  },

  computed: {
    isViewing() {
      return this.type == "view";
    },
    isEditing() {
      return this.type == "edit";
    },
    editRules() {
      if (this.isViewing) {
        return {};
      }
      return {
        name: [
          { required: true, message: "该项为必填项" },
          { min: 1, max: 50, message: "输入内容长度必须介于1到50之间" },
        ],
        remark: [
          // { required: true, message: "该项为必填项" },
          { min: 1, max: 100, message: "输入内容长度必须介于1到100之间" },
        ],
        orgId: [{ required: true, message: "该项为必选项" }],
      };
    },
  },

  methods: {
    onActive() {
      let { id, type } = this.tabRouteParam || {};
      this.id = id;
      this.type = type;
      this.getDetail();
    },

    getDetail() {
      groupDetailService({ groupId: this.id })
        .then((res) => {
          if (res.code == Variables.Code_OK) {
            this.formData = res.data || {};
            // 群组里已经有的人
            this.userRelationList = this.formData.userRelationList || [];
            this.orgId = this.formData.orgId;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$message.error(Variables.Err_Msg);
        });
    },

    addMember() {
      // 吊起窗口来选
      this.dialogVisible = true;
    },
    removeUser(item) {
      // 从外面直接删除已有的人
      try {
        let index = this.userRelationList.findIndex(
          (ele) => ele.userId == item.userId
        );
        if (index >= 0) {
          this.userRelationList.splice(index, 1);
        }
      } catch (error) {
        console.log("error:", error);
      }
    },

    doCancel() {
      //  取消就关掉当前页
      this.bus.$emit("tabClose", "groupDetail");
    },

    doSubmit() {
      let ids = [];
      this.userRelationList.forEach((user) => {
        ids.push(user.userId);
      });
      let params = {
        id: this.formData.id,
        name: this.formData.name,
        orgId: this.formData.orgId,
        remark: this.formData.remark,
        isDefault: this.formData.isDefault,
        userList: ids,
      };

      this.rightUserList = [];

      modifyGroupService(params)
        .then((res) => {
          if (res.code == Variables.Code_OK) {
            this.$alert(Variables.Ok_Msg, "提示", {
              confirmButtonText: "确定",
            });
            this.type = "view";
            this.getDetail();
          } else {
            this.$alert(res.msg, "确定");
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },

    middleAllSelected() {
      // 点击全选，此时如果中间有备选项，就全部添加过去
      // 这里置从userlist里选，因为创建群组时只能添加个人，不能选择组织
      if (!this.middleUserList || this.middleUserList.length == 0) {
        return;
      }
      this.middleUserList.forEach((midUser) => {
        // 遍历mid，对每一个做判断，如果在right里没有，就添加进去。已经有了就不管了
        let index = this.rightUserList.findIndex(
          (rightUser) => rightUser.id == midUser.id
        );
        if (index == -1) {
          this.rightUserList.push(midUser);
        }
      });
    },

    treeNodeClick(data, node) {
      // data就是node.data
      if (data.id != this.currentDepartId) {
        this.currentDepartId = data.id;
        getSubUserService({ deptId: data.id })
          .then((res) => {
            if (res.code == Variables.Code_OK) {
              this.middleDepartList = (res.data || {}).deptList || [];
              this.middleUserList = (res.data || {}).userList || [];
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$message.error(Variables.Err_Msg);
          });
      }
    },
    // 根级先根据orgId获取该组织下有哪些部门，然后再根据一级一级的部门去获取下属的列表
    loadNode(node, resolve) {
      if (node.level == 0) {
        let reqParam = {
          pid: 0,
          orgId: this.orgId,
        };
        getDeptListService(reqParam)
          .then((res) => {
            if (res.code == Variables.Code_OK) {
              let list = res.data || [];
              resolve(list);
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$message.error(Variables.Err_Msg);
          });
      } else {
        // 去获取各级的数据
        getSubService({ deptId: node.data.id })
          .then(res => {
            if (res.code == Variables.Code_OK) {
              resolve(res.data || []);
            } else {
              this.$alert(res.msg, '提示');
              resolve([]);
            }
          })
          .catch((error) => {
            console.log("loadNode error==", error);
          });
      }
    },
    isTabDisabled(tab) {
      if (tab == "depart") {
        return true;
      } else {
        return false;
      }
    },
    changeTab(tab) {
      if (this.isTabDisabled(tab)) {
        return;
      }
      if (tab != this.currentTab) {
        this.currentTab = tab;
      }
    },
    isDepartSelected(depId) {
      let index = this.rightDepartList.findIndex((ele) => ele.id == depId);
      return index >= 0;
    },
    isUserSelected(userId) {
      let index = this.rightUserList.findIndex((ele) => ele.id == userId);
      return index >= 0;
    },
    changeSelectDept(dept) {
      let list = this.rightDepartList;
      let index = list.findIndex((ele) => ele.id == dept.id);
      if (index >= 0) {
        list.splice(index, 1);
      } else {
        list.push(dept);
      }
      this.$set(this, "rightDepartList", list);
    },
    changeSelectUser(user) {
      // 在中间选择了人
      let index = this.rightUserList.findIndex((ele) => ele.id == user.id);
      if (index >= 0) {
        this.rightUserList.splice(index, 1);
      } else {
        this.rightUserList.push(user);
      }
    },

    removeAllRight() {
      this.rightDepartList = [];
      this.rightUserList = [];
    },
    removeRightUser(user) {
      // 点击右侧移除某个人
      let index = this.rightUserList.findIndex((ele) => ele.id == user.id);
      if (index >= 0) {
        this.rightUserList.splice(index, 1);
      }
    },
    submitSelectedList() {
      // 关闭dialog，如果提成单个组件，这里就发出选择的列表
      this.dialogVisible = false;
      this.rightUserList.forEach((rightUser) => {
        let index = this.userRelationList.findIndex(
          (user) => user.userId == rightUser.id
        );
        if (index == -1) {
          // 从选择框选择的人是id和name，但是从detail接口回来的人员列表是分id userId userName，这里的id和选择框的id不是一个东西，userId才是选择框的id
          // 所以这里要新加个userId属性，在保存修改时使用
          let add = {
            ...rightUser,
            userName: (rightUser.displayName || rightUser.name),
            userId: rightUser.id,
          };
          this.userRelationList.push(add);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.group-detail {
  background: #fff;
  padding: 15px;
  width: 60%;
}

.member_c {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.selected_c {
  min-height: 200px;
  overflow-y: auto;
  flex: 1;
  margin-right: 10px;
  text-align: left;
  border: 1px solid #dcdfe6;
  padding: 10px;

  /deep/.el-tag {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

.empty_c {
  min-height: 200px;
  flex: 1;
  margin-right: 10px;
  height: 200px;
  font-size: 20px;
  line-height: 200px;
  text-align: center;
  border: 1px dashed #dcdfe6;
}

//----------------
.choose_c {
  display: flex;
  width: 100%;
  justify-content: space-between;
  border: 1px solid #dcdfe6;
}

.wrapper {
  flex: 1;
}

.title_c {
  font-size: 20px;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid #cdcdcd;
}

.wrapper + .wrapper {
  border-left: 1px solid #cdcdcd;
}

.head_c {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  border-bottom: 1px solid #cdcdcd;

  .el-checkbox {
    margin-left: 5px;
  }

  .el-button {
    margin-left: 5px;
  }
}

.tab {
  width: 50%;
  cursor: pointer;
  padding-top: 5px;
  padding-bottom: 5px;
}

.tab-active {
  color: #079dbd;
}

.tab + .tab {
  border-left: 1px solid #cdcdcd;
}

.body_c {
  height: 400px;
  overflow: auto;
}

.result_c,
.candidate_c {
  .el-tree-node__content {
    padding-left: 6px;
  }
}

.result_c .el-tree-node__content i {
  margin-right: 6px;
}

.footer {
  text-align: center;
  padding: 20px 0;
}

/deep/.el-select {
  width: 100%;
}
</style>
